import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoFull from "./../assets/images/logo-report.png";
export function download_pdf(options, dataArr  = [], callback = null) {

    imgToBase64(
        logoFull,
      (headerImg, headerWidth, headerHeight) => {
        download_pdfFile(
            options,
            dataArr,
            headerImg,
            headerWidth,
            headerHeight,
             
            (d) => {
              if (callback) {
                callback(false);
              }
            }
          )
      }
    );
  }

  function download_pdfFile(
    options,
    dataArr  ,
    headerImg,
    headerWidth,
    headerHeight,
    footerImg,
    footerWidth,
    footerHeight,
    callback = null,
    vendorImg = null,
    vendorWidth = null,
    vendorHeight = null
  )  {
    let filename = options.filename ? options.filename.trim() : "EFH";
    let heading = options.heading;
    let pagetype = options.pagetype;
    let sizeunit = options.sizeunit;
    let pdfPWidth = options.pdfPWidth;
    let pdfPHeight = options.pdfPHeight;
    let headerTitleShow = options.headerTitleShow ? options.headerTitleShow : true;
    let imageonoff = options.imageonoff ? options.imageonoff : true;
    let footerCallMultiTime = options.footerCallMultiTime
      ? options.footerCallMultiTime
      : false;
    let headhtml = options.headhtml;

    let doc;

    if (
      pagetype != '' &&
      sizeunit != '' &&
      pdfPWidth != '' &&
      pdfPHeight != ''
    ) {
      doc = new jsPDF(pagetype, sizeunit, [pdfPWidth, pdfPHeight]);



      if (options.pageBackground) {
        doc.setDrawColor(0);
        doc.setFillColor(options.pageBackground[0]);
        doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'F');
      }


    } else {
      return;
    }

    //One of 'a3', 'a4' (Default),'a5' ,'letter' ,'legal'
    //doc = new jsPDF('p', 'in', "a4");

    var totalPagesExp = '{total_pages_count_string}';

    doc.setFontSize(8);
    let pageHeight =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    let pageWidth =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    headerWidth = headerWidth / 100;
    headerHeight = headerHeight / 100;
    const imgRatio = headerWidth / headerHeight;
    if (headerWidth > 2) {
      headerWidth = 2;

      if (headerHeight > 2) {
        headerHeight = 0.8;
      }
    }


    vendorWidth = vendorWidth / 100;
    vendorHeight = vendorHeight / 100;
    if (vendorWidth > 2) {
      vendorWidth = 2;
      if (vendorHeight > 2) {
        vendorHeight = 0.8;
      }
    }







    var margint_top = headerHeight + 0.3;

    /*
  doc.setProperties({
   title: 'Title',
   subject: 'This is the subject',
   author: 'Author Name',
   keywords: 'generated, javascript, web 2.0, ajax',
   creator: 'Mahendra'
  });
  */
    var specialElementHandlers = {
      '#editor': function (element, renderer) {
        return true;
      },
    };

    var pageContent = function (data) {
      // HEADER

      doc.setFontSize(12);

      doc.setTextColor(255, 255, 255);
      doc.text(heading, pageWidth / 2, 0.3, 'center');
      doc.margins = 4;
      // doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 15, 10, 10);
      //  doc.text("Report", data.settings.margin.left + 15, 22);

      // FOOTER
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        var str = 'Page ' + data.pageCount;
        str = str + ' of ' + totalPagesExp;
      }

      doc.setFontSize(6);
      doc.text(str, data.settings.margin.left, pageHeight - 0.1);
    };

    ///////////////// ----------- Header Setting  Start----------/////




    addHeaders(
      doc,
      imageonoff,
      headerImg,
      headerWidth,
      headerHeight,
      headhtml,
      vendorImg,
      vendorWidth,
      vendorHeight
    );
    if (headerTitleShow) {
      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.text(heading, pageWidth / 2, 0.3, 'center');
    }



    /*  doc.setFontSize(8);
    var whatsInThisDiv =htmsl.replace(/<[^>]+>/g, '');
        doc.text(whatsInThisDiv, (headerWidth+1),(headerHeight/1.2), 'left'); */
    if (dataArr.length > 0) {


      dataArr.forEach((d) => {
        let finalY = doc.previousAutoTable.finalY;
        finalY = finalY ? finalY : 0;

        let imageWidth = 8;
        let imageHeight = 4;
        let titleHeight = 0.35;
        let positionImg = '';
        let marginLeft = 0.1;
        let marginTop = 0;

        /* autoTable({
          showHead: 'firstPage', //everyPage'|'firstPage'|'never' = 'everyPage''
          didDrawPage: pageContent,
          margin: {
            //top: margint_top,
            top: 0.5,
            left: 0.2,
            right: 0.2,
            bottom: 0.2,
          },
        }) */


        ///////////////// ----------- Header Setting  End----------/////
        if (d.images) {
          if (d.imagesOptions) {
            if (d.imagesOptions['width']) { imageWidth = d.imagesOptions['width'] }
            if (d.imagesOptions['height']) { imageHeight = d.imagesOptions['height'] }
            if (d.imagesOptions['positionImg']) { positionImg = d.imagesOptions['positionImg'] }
            if (d.imagesOptions['marginLeft']) { marginLeft = d.imagesOptions['marginLeft'] }
            if (d.imagesOptions['marginTop']) { marginTop = d.imagesOptions['marginTop'] }
          }
          if (!positionImg) {
            if (margint_top + imageHeight + titleHeight > pageHeight) {
              doc.addPage();
              margint_top = 0.2;
            } else {
              if (finalY) {
                margint_top = finalY;
              }
            }
          }

          addTitle(doc, d.title, margint_top);
          // 'GIF',

          doc.addImage(
            d.images,
            "GIF",
            marginLeft,
            positionImg ? margint_top - imageHeight : margint_top + titleHeight + marginTop,
            imageWidth,
            imageHeight
          );
          if (!positionImg) {
            margint_top = margint_top + imageHeight + titleHeight;
          }

        } else {
          if (d.rows.length > 0) {
            if (finalY) {
              addTitle(doc, d.title, finalY);
              margint_top = finalY + titleHeight;
            } else {
              addTitle(doc, d.title, margint_top);
              margint_top = margint_top + 0.6;
            }


            autoTable(doc, {
              head: [d.columns],
              body: d.rows,
              showHead: 'firstPage', //everyPage'|'firstPage'|'never' = 'everyPage''
              //showFoot: 'firstPage',   //everyPage'|'lastPage'|'never' = 'everyPage''
              didDrawPage: pageContent,

              margin: {
                //top: margint_top,
                top: 0.5,
                left: 0.2,
                right: 0.2,
                bottom: 0.2,
              },
              tableWidth: 'auto',
              //cellWidth: 'auto',
              theme: 'grid', //striped or grid, plain
              // columnStyles: { id: {fillColor: 255}  },
              startY: margint_top,
              styles: {
                cellPadding: 0.2,
                fontSize: 8,
                valign: 'middle',
                overflow: 'linebreak',
                //tableWidth: 'auto',
                lineWidth: 0,
                // cellWidth: 'auto',
              },
              headStyles: {
                //cellWidth: 'wrap',
                cellPadding: 0.1,
                lineWidth: 0,
                valign: 'top',
                fontStyle: 'bold',
                halign: 'left', //'center' or 'right'
                fillColor: [41, 128, 186],
                textColor: [255, 255, 255], //White
                fontSize: 8,
              },
              bodyStyles: {
                //cellWidth: 'wrap',
                cellPadding: 0.1,
                fillColor: [255, 255, 255],
                lineWidth: 0.01,
                lineColor: [233, 235, 241],
                textColor: [0, 0, 0],
                fontSize: 7,

              },
              columnStyles: d.columnStyles,
              /*   columnStyles: {
       0: { cellWidth: 'wrap' }, //cellWidth(wrap/auto/.8),  fillColor: [20, 192, 126], textColor: 255,  fontStyle: 'bold', opacity: 0.2,
    }   */
            });
          }else if ( d.title) {
            addTitle(doc, d.title, finalY);
            margint_top = margint_top + 0.6;
          }




        }

        if (d.columeFooterLagend) {
          createLabel(
            doc,
            d.columeFooterLagend,
            doc.previousAutoTable.finalY + 0.2
          );
        }
      });
    }

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    const pageCount = doc.internal.getNumberOfPages();

    for (var i = 1; i <= pageCount; i++) {
      if (footerCallMultiTime) {
        addFooters(doc, footerImg, i, pageCount, false, dataArr);
      } else {
        if (i == pageCount) {
          addFooters(doc, footerImg, pageCount, pageCount, false, dataArr);
        } else {
          addFooters(doc, footerImg, i, pageCount, true, dataArr);
        }
      }
    }

    doc.save(`${filename}.pdf`);
    if (callback) {
      callback();
    }
  }



  function  addHeaders(doc, imageonoff, headerImg, headerWidth, headerHeight, headhtml, vendorImg = null,
    vendorWidth = null,
    vendorHeight = null) {
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);

    doc.setDrawColor(8, 38, 70);
    doc.setFillColor(8, 38, 70);
    doc.rect(0, 0, doc.internal.pageSize.width, 0.6, 'FD');
    doc.setDrawColor(13, 110, 253);
    doc.setFillColor(13, 110, 253);

    doc.setLineWidth(0.08);
   // doc.line(0, 0.7, doc.internal.pageSize.width, 0.7);
    if (headerImg) {
      if (imageonoff == true) {
        doc.addImage(
          headerImg,
          'JPEG',
          0.05,
          0.05,
          headerWidth / 1.2,
          headerHeight / 1.2
        );
      }
    }


    if (vendorImg) {

      doc.addImage(
        vendorImg,
        'JPEG',
        doc.internal.pageSize.width - 1.5,
        0.10,
        vendorWidth / 1.6,
        vendorHeight / 1.6
      );

    }


    doc.setFont('helvetica');
    doc.setFontSize(8);

    doc.setTextColor(255, 255, 255);

    doc.text(headhtml, doc.internal.pageSize.width / 2, 0.47, {
      align: 'center',
    });





    //var htmsl=` <span id="pdf_head_data" style="width:200px; float:left"> ${headhtml}   </span>`;

    // doc.fromHTML(htmsl,(headerWidth+1),(headerHeight/1.2),{},{},{top: 0});
  }



  function imgToBase64(url, callback) {
    /*    if (!window.FileReader) {
          callback(null,null,null);
          return;
        }*/
    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
      var reader = new FileReader();


      reader.onloadend = function (data) {
        var exprots = reader.result;
        exprots = exprots.replace('text/xml', 'image/jpeg');
        var images = document.createElement('img');
        images.src = exprots;
        images.onload = function (data) {

          callback(exprots, images.width, images.height);

        };


      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.send();

  }


  function createLabel(doc, data, pageHeight) {
    let x = 0.1;
    data.forEach((d, i) => {
      let w = doc.getTextDimensions(d.name);
      //x=x+w.w;

      doc.setDrawColor(...d['fillColor']);
      doc.setFillColor(...d['fillColor']);

      doc.rect(x, pageHeight, 0.5 + w.w, 0.2, 'FD');
      doc.setTextColor(d.textColor[0]);
      doc.setFontSize(8);
      doc.text(d.name, x + 0.2, pageHeight + 0.15);
      x += 0.5 + w.w;
    });
  }
  function addTitle(doc, title, finalY) {
    if (title) {
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);

      var lines = doc.splitTextToSize(title, 7.5);
      // doc.text(0.5, 1, lines);
      // doc.text(lMargin,20,lines);

      // doc.text(title, 0.2, finalY ? finalY + 0.3 : 1, 'left');
      doc.text(0.2, finalY ? finalY + 0.3 : 1, lines);
    }
  }



  function  addFooters(doc, footerImg, i, pageCount, shortInfo = false, data=[]) {
    const pageHeight = doc.internal.pageSize.height - 0.5;

    doc.setPage(i);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(10);
    if (shortInfo) {
      doc.setTextColor(0, 0, 0);

      doc.text(
        'Page ' + String(i) + ' of ' + String(pageCount),
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.1,
        {
          align: 'center',
        }
      );
    } else {
      // legend Display pass dynamicly

      doc.setDrawColor(13, 110, 253);
      doc.setFillColor(13, 110, 253);

      doc.setLineWidth(0.06); 
      doc.setDrawColor(8, 38, 70);
      doc.setFillColor(8, 38, 70);
      doc.rect(0, pageHeight + 0.06, doc.internal.pageSize.width, 0.6, 'FD');

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(  10);

      doc.setFont('bold');
      doc.text(` `, 0.2, pageHeight + 0.32, {
        align: 'left',
      });

      doc.text(
        'Page ' + String(i) + ' of ' + String(pageCount),
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.18,
        {
          align: 'center',
        }
      );
/* 
      if(footerImg){
      doc.addImage(
        footerImg,
        'JPEG',
        doc.internal.pageSize.width - 1.9,
        doc.internal.pageSize.height - 0.42,
          1.69291,
         0.393701
      );

    } */
    }
  }